module.exports = __webpack_public_path__ + "img/section2_1.bd35838f.png";